import { swSettings } from "app/common/services/swSettings";
import { GrowthbookService, TestsNames } from "app/services/trackingServices/GrowthBookService";
import { TestValues } from "app/services/trackingServices/types";
import { isAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

export const shouldShowAfterTrialDigitalSuiteHomeSidebar = (
    isAfterTrialUser: boolean,
    growthbookFeatureValue: string,
): boolean => {
    if (isAfterTrialUser) {
        return growthbookFeatureValue.toLowerCase() === TestValues.VARIATION.toLowerCase();
    }

    return false;
};

export const isAfterTrialDigitalSuiteHomeSidebarVisible = (): boolean => {
    const featureValue = GrowthbookService.growthbookInstance.getFeatureValue(
        TestsNames.AFTER_TRIAL_DS_HOME_SIDEBAR,
        TestValues.CONTROL,
    );

    return shouldShowAfterTrialDigitalSuiteHomeSidebar(isAfterTrial(swSettings), featureValue);
};
